export const parseQueryString = <T extends Record<string, unknown>>(query: string) => {
  return query
    .replace('?', '')
    .split('&')
    .map((entry) => {
      const [key, value] = entry.split('=');
      return { key, value };
    })
    .reduce((acc, { key, value }) => {
      // typescript 한계로 에러가 남
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acc[key] = value;
      return acc;
    }, {} as T);
};
